module.exports = __webpack_public_path__ + "static/img/icon_lock.4de9172c.svg";